import React, { useState, useEffect } from 'react';

const navLinks = [
  { label: 'About', href: '#about' },
  { label: 'Experience', href: '#experience' },
  { label: 'Projects', href: '#projects' },
  { label: 'Skills', href: '#skills' },
  { label: 'Blog', href: '#blog' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(e => { if (e.isIntersecting) setActive(e.target.id); });
      },
      { rootMargin: '-40% 0px -55% 0px' }
    );
    document.querySelectorAll('section[id]').forEach(s => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100,
      background: scrolled ? 'rgba(250,249,247,0.92)' : 'transparent',
      backdropFilter: scrolled ? 'blur(12px)' : 'none',
      borderBottom: scrolled ? '1px solid var(--border)' : '1px solid transparent',
      transition: 'all 0.3s ease',
      padding: '0 clamp(24px, 5vw, 80px)',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 }}>
        <a href="#hero" style={{ display: 'flex', alignItems: 'center', lineHeight: 1 }}>
          <img
            src="/signature.png"
            alt="Dewmith Akalanka"
            style={{
              height: 36,
              width: 'auto',
              objectFit: 'contain',
              filter: 'brightness(0) saturate(100%)', /* render as pure ink-black */
              opacity: 0.85,
              transition: 'opacity 0.2s',
            }}
            onMouseEnter={e => { e.currentTarget.style.opacity = '1'; }}
            onMouseLeave={e => { e.currentTarget.style.opacity = '0.85'; }}
          />
        </a>

        {/* Desktop links */}
        <div style={{ display: 'flex', gap: 36, alignItems: 'center' }} className="nav-desktop">
          {navLinks.map(l => (
            <a key={l.href} href={l.href} style={{
              fontFamily: 'var(--font-mono)', fontSize: 12, letterSpacing: '0.06em',
              textTransform: 'uppercase', color: active === l.href.slice(1) ? 'var(--accent-warm)' : 'var(--ink-2)',
              transition: 'color 0.2s', fontWeight: active === l.href.slice(1) ? 500 : 300,
            }}>{l.label}</a>
          ))}
          <a href="mailto:akalankadewmith@gmail.com" style={{
            fontFamily: 'var(--font-mono)', fontSize: 11, letterSpacing: '0.08em',
            textTransform: 'uppercase', border: '1px solid var(--ink)', padding: '7px 18px',
            color: 'var(--ink)', transition: 'all 0.2s', borderRadius: 2,
          }}
            onMouseEnter={e => { e.target.style.background = 'var(--ink)'; e.target.style.color = 'var(--cream)'; }}
            onMouseLeave={e => { e.target.style.background = 'transparent'; e.target.style.color = 'var(--ink)'; }}
          >Hire Me</a>
        </div>

        {/* Mobile hamburger */}
        <button onClick={() => setMenuOpen(!menuOpen)} style={{
          display: 'none', background: 'none', border: 'none', cursor: 'pointer',
          flexDirection: 'column', gap: 5, padding: 4,
        }} className="nav-mobile-btn" aria-label="Menu">
          {[0, 1, 2].map(i => (
            <span key={i} style={{
              display: 'block', width: 24, height: 1.5, background: 'var(--ink)',
              transition: 'all 0.3s',
              transform: menuOpen ? (i === 0 ? 'rotate(45deg) translateY(9px)' : i === 2 ? 'rotate(-45deg) translateY(-9px)' : 'scaleX(0)') : 'none',
            }} />
          ))}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div style={{
          background: 'var(--cream)', borderTop: '1px solid var(--border)',
          padding: '24px clamp(24px, 5vw, 80px)', display: 'flex', flexDirection: 'column', gap: 20,
        }}>
          {navLinks.map(l => (
            <a key={l.href} href={l.href} onClick={() => setMenuOpen(false)}
              style={{ fontFamily: 'var(--font-mono)', fontSize: 13, color: 'var(--ink-2)', letterSpacing: '0.06em', textTransform: 'uppercase' }}>
              {l.label}
            </a>
          ))}
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .nav-desktop { display: none !important; }
          .nav-mobile-btn { display: flex !important; }
        }
      `}</style>
    </nav>
  );
}
